import "./class-component-hooks"; // needs to be imported before any components
import Vue from "vue";
// Lokal gebundelte Schrift/Icons statt CDN (DSGVO): ersetzt die frueheren
// <link>-Tags auf fonts.googleapis.com und cdn.jsdelivr.net in index.html.
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./assets/main.css";
// @ts-ignore
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Moment from "moment";
import "./log.js";
import FloatingVue, { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";

Vue.filter("formatDate", (value: any) => {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY");
	}
});

Vue.filter("formatDateTime", (value: any) => {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY HH:mm");
	}
});

Vue.filter("formatTimespan", (value: any) => {
	if (value) {
		return Moment(String(value)).format("hh:mm:ss");
	}
});

Vue.filter("round2Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		value = Math.round(value * 100) / 100;
		return value.toFixed(2);
	}
});

Vue.filter("round3Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		value = Math.round(value * 1000) / 1000;
		return value.toFixed(3);
	}
});

Vue.filter("format2Digits", (value: number) => {
	if (value !== undefined && value !== null) {
		return value.toLocaleString(undefined, { minimumIntegerDigits: 2 });
	}
});

Vue.filter("format2Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		return value.toFixed(2);
	}
});

Vue.config.productionTip = false;
console.log("running: " + process.env.VUE_APP_MODE);

// Floating Vue used for hint tooltips
// https://floating-vue.starpad.dev/
Vue.use(FloatingVue);

// Checking if this request is a logout request
// eg. if the user changes their email address they are
// routed to a shop-logout.
// If they are not logged in, they must be routed to the login mask.
const urlHash = window.location.hash;
let isLogoutRedirect = false;
if (urlHash === "#/Logout" || urlHash === "#/Logout/") {
	isLogoutRedirect = true;
}

// Setup main page
store
	.dispatch("bootstrap")
	.then(async () => {
		console.log("Successfully bootstrapt application");
		if (isLogoutRedirect) {
			store.dispatch("logout");
		} else {
			store
				.dispatch("checkAccess")
				.then(async () => {
					store.dispatch("setupSignalR").then(() => {
						const app = new Vue({
							router,
							store,
							vuetify,
							i18n,
							render: (h) => h(App),
						}).$mount("#app");
					});
				})
				.catch((e) => {
					console.log("Keine Berechtigung");
					store.dispatch("logout");
				});
		}
	})
	.catch((e) => console.log(e));
